import React, { useEffect, useState } from 'react'

import {
  Box,
  TablePagination,
  useMediaQuery,
  Grid,
  CircularProgress,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

import usePagination from 'hooks/usePagination'

import { DataProcessCard } from 'components'
import useFilter from 'hooks/useFilter'

import * as service from 'service'
import constants from 'constants/index'

const DataProcessesDiscarded = ({ dataProcesses, setDataProcesses }) => {
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(12)

  const [isLoading, setIsLoading] = useState(true)

  const filter = useFilter()
  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  useEffect(() => {
    const loadDataProcess = async () => {
      const response = await service.dponet.dataProcesses.discarded({
        //alterar endpoint para rota em desenvolvimento
        perPage,
        page,
        ...{ ...filter.filters },
      })
      setDataProcesses(response?.data)
      if (isLoading) {
        setIsLoading(false)
      }
    }
    loadDataProcess()
    //eslint-disable-next-line
  }, [isLoading, page, perPage, filter.filters])

  return (
    <>
      {isLoading ? (
        <Box
          id="loadBox"
          display="flex"
          width="100%"
          minHeight="700px"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Box display="flex" width="100%" mt={5}>
            <Grid container spacing={3}>
              <DataProcessCard
                xl={3}
                lg={4}
                md={4}
                sm={6}
                xs={12}
                dataProcesses={dataProcesses?.dataProcesses}
                isLoading={isLoading}
                origin={constants.dataProcess.CARD_ORIGIN_DISCARDED}
                setIsLoading={setIsLoading}
                defaultStatus={constants.dataProcess.DISCARDED}
              />
            </Grid>
          </Box>
          <TablePagination
            component="div"
            count={dataProcesses.meta.totalCount}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[4, 12, 36, 100]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      )}
    </>
  )
}

export default DataProcessesDiscarded
